import router from "@/router";
import { Endpoints } from "@/api/ApiEndpoints";
import { Paths } from "@/core/config/enums/SitePaths";
import { Inputs, validationSchema } from "@/entities/Sponsors/SponsorsFormInputs";

const Sponsors = {
  Plural: "Sponsors",
  Single: "Sponsor",
  IsPage: true,
  FormWithImage: true,
  Inputs: Inputs,
  Relationships: [
    {
      name: "countryIds",
      endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
      mapping: (response: any) => response,
      dataMapping: (response: any) => response,
    },
  ],
  ValidationSchema: validationSchema,
  SaveCallBack: (id: number) => {
    router.push(Paths.SPONSORS_EDIT.replace(":id", String(id)));
  },
};

export default Sponsors;
